import React, {useEffect, useState} from 'react';
import LOGO from '../../../assets/images/headers/KDA-Logo.jpg';
import ROUTES from '../../../routes';
import {Link, useLocation} from 'react-router-dom';
import Menu from '../Menu/menu';
import Translator from '../../components/common/Translator';

const Index = () => {
  const location = useLocation();
  const [showMenu, setShowMenu] = useState(false);

  useEffect(() => {
    setShowMenu(false);
  }, [location]);

  return <>
    <div className='white-bg-color padding-2 hide-for-print'>
      <div className='grid-container'>
        <div className='grid-x grid-margin-x'>
          <div className='auto cell small-order-1'>
            <Link to={ROUTES.ROOT}>
              <img
                alt='logo'
                src={LOGO}
                width={300}
              />
            </Link>
          </div>
          <div className='medium-shrink cell text-right small-order-3 medium-order-2'>
            <Translator/>
          </div>
          <div className='shrink cell small-order-2 medium-order-3'>
            <button
              className='nav-button'
              onClick={() => setShowMenu(!showMenu)}
              type='button'>Navigation Menu
            </button>
          </div>
        </div>
      </div>
    </div>
    <div className='show-for-print margin-bottom-1'>
      <img
        alt='logo'
        className='width-50'
        src={LOGO}
      />
    </div>
    <Menu
      isShown={showMenu}
      setShowMenu={setShowMenu}/>
  </>;
};

export default Index;
